<template>
  <div class="modal-card">
    <b-loading :isFullPage="false" :active="isLoading" />
    <header class="modal-card-head">
      <span class="modal-card-title is-size-5 has-text-centered">
        {{ App.EDOWebEditor.SUSPENDED_LIST }}
      </span>
      <div class="close-button cursor-pointer" @click.stop="onCancel">
        <b-icon icon="close" />
      </div>
    </header>

    <div class="modal-content-container">
      <section class="spacing-p-20">
        <b-field
          class="min-size mx-4"
          customClass="has-text-color-7"
          :label="`${General.FIELD_NAME}:`"
        >
          <b-input
            v-model="inputName"
            :placeholder="App.EDOWebEditor.PLACEHOLDER_NAME"
          />
        </b-field>
        <b-field
          class="min-size spacing-my-10"
          customClass="has-text-color-7"
          :label="App.EDOWebEditor.OPTION_LABEL"
        >
          <section>
            <b-field v-for="(option, index) in options" :key="index">
              <b-input
                :value="option"
                :placeholder="App.EDOWebEditor.TYPE_RESPONSE_OPTION"
                expanded
                @input="text => (options[index] = text)"
              />
              <b-button
                v-if="index === options.length - 1"
                class="button-action"
                @click="
                  () => {
                    options.push(newOption.trim());
                    newOption = '';
                  }
                "
              >
                <b-icon
                  icon="plus-circle"
                  :type="isContrast ? 'is-white' : 'is-green-lawn'"
                />
              </b-button>
              <b-button
                v-else
                class="button-action"
                @click="() => options.splice(index, 1)"
              >
                <b-icon
                  icon="minus-circle"
                  :type="isContrast ? 'is-white' : 'is-warning'"
                />
              </b-button>
            </b-field>
          </section>
        </b-field>
      </section>

      <footer class="modal-card-foot is-justify-content-space-between">
        <b-field class="m-0">
          <b-switch
            v-model="isMandatory"
            class="has-text-color-7"
            :trueValue="true"
            :falseValue="false"
          >
            {{ App.EDOWebEditor.MANDATORY }}
          </b-switch>
        </b-field>
        <div class="buttons">
          <b-button
            :type="isContrast ? 'is-white' : 'is-green-lawn'"
            @click="confirmAction"
          >
            {{ General.SAVE }}
          </b-button>
          <b-button
            :type="isContrast ? 'is-white' : 'is-warning'"
            outlined
            @click="onCancel"
          >
            {{ General.CANCEL }}
          </b-button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import { App, General } from "@/utils/constants";

export default {
  name: "ModalAddSelectDoe",

  props: {
    submit: {
      type: Function,
      required: true,
      default: () => null
    }
  },

  data() {
    return {
      App,
      General,
      isLoading: false,
      isMandatory: false,
      inputName: "",
      newOption: "",
      options: [""]
    };
  },

  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },

  methods: {
    ...mapActions({
      indexerCreate: "indexerCreate",
      indexerRequest: "indexerRequest"
    }),
    inputCode() {
      const newOption = this.newOption.trim();
      const options = newOption.length
        ? [...this.options, newOption]
        : this.options;
      return `<select required=${
        this.isMandatory
      } class="select-${this.inputName.toUpperCase()}" name="select-${this
        .inputName +
        " - " +
        this.isMandatory}"><option selected disabled="true">${
        this.inputName
      }</option>${options
        .map(option => ` <option value='${option}'>${option}</option>`)
        .join("")}</select>`;
    },

    confirmAction() {
      if (!this.inputName)
        this.snackToast.open({
          message: `${this.General.TYPE_NAME}.`,
          type: "is-danger",
          duration: 5000
        });
      else if (/\W/gi.test(this.inputName))
        this.snackToast.open({
          message: `${this.App.EDOWebEditor.FAIL_INPUT}.`,
          type: "is-danger",
          duration: 5000
        });
      else if (!this.options.length)
        this.snackToast.open({
          message: `${this.App.EDOWebEditor.SELECT_OPTIONS}.`,
          type: "is-danger",
          duration: 5000
        });
      else {
        const newInput = {
          name: this.inputName.toUpperCase(),
          value: this.inputCode(),
          isMandatory: this.isMandatory
        };
        this.submit(newInput);

        this.close();
      }
    },

    close() {
      this.$parent.close();
    },
    onCancel() {
      this.submit(null);
      this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.modal-card {
  display: flex;
  justify-content: space-between;
  width: 100%;
  min-width: 50vw;
  min-height: 100px;
  max-height: 75vh;
  background-color: $color-1;
}
.list-container {
  overflow: auto;
}

.header-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.card-body {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid;
  border-bottom-color: #cdcdcd;
}

.modal-content-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: space-between;
  overflow: auto;
}

.min-size {
  min-width: 100px;
}

.button-action {
  margin: 0px 5px;
  border: none;
  background-color: transparent;
}
</style>
